// extracted by mini-css-extract-plugin
module.exports = {"CardsArea":"CardsArea_CardsArea__1-LKV"};